import { render, staticRenderFns } from "./redpotie.vue?vue&type=template&id=d4dc6042&"
import script from "./redpotie.vue?vue&type=script&lang=js&"
export * from "./redpotie.vue?vue&type=script&lang=js&"
import style0 from "./redpotie.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports